export default __webpack_public_path__ + "static/media/logo.0c78ec72.png";